<div
  class="session-expired"
  role="alertdialog"
  aria-modal="true"
  aria-labelledby="session-expired-title"
  aria-describedby="session-expired-subtitle"
>
  <div class="session-expired__backdrop" aria-hidden="true"></div>

  <div class="session-expired__card">
    <div class="session-expired__orb" aria-hidden="true"></div>

    <div class="session-expired__ring-wrapper">
      <svg class="session-expired__ring" viewBox="0 0 100 100" aria-hidden="true">
        <defs>
          <linearGradient id="seRingGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#fbd396" />
            <stop offset="100%" stop-color="#e8946b" />
          </linearGradient>
        </defs>
        <circle
          class="session-expired__ring-track"
          cx="50"
          cy="50"
          r="42"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        />
        <circle
          class="session-expired__ring-progress"
          cx="50"
          cy="50"
          r="42"
          fill="none"
          stroke="url(#seRingGradient)"
          stroke-width="3"
          stroke-linecap="round"
          [attr.stroke-dasharray]="circumference"
          [attr.stroke-dashoffset]="ringOffset()"
          transform="rotate(-90 50 50)"
        />
      </svg>
      <span class="session-expired__count" aria-live="polite">{{ remaining() }}</span>
    </div>

    <div class="session-expired__heading">
      <span class="session-expired__accent-bar" aria-hidden="true"></span>
      <h1 id="session-expired-title" class="session-expired__title">
        {{ 'sessionExpired.title' | translate }}
      </h1>
    </div>

    <p id="session-expired-subtitle" class="session-expired__subtitle">
      {{ 'sessionExpired.subtitle' | translate }}
    </p>

    <div class="session-expired__divider" aria-hidden="true"></div>

    <div class="session-expired__footer">
      <span class="session-expired__countdown-text">
        {{ 'sessionExpired.countdown' | translate: { seconds: remaining() } }}
      </span>
      <button
        type="button"
        class="session-expired__cta"
        (click)="onActionClick()"
      >
        <span>{{ 'sessionExpired.cta' | translate }}</span>
        <span class="session-expired__cta-arrow" aria-hidden="true">→</span>
      </button>
    </div>
  </div>
</div>
